export function removeMargin() {
    if (!$('.services-add-info .cascade:last').length){
        $('.services-add-info').addClass('reset-margin');
    }
}


// WEBPACK FOOTER //
// ./assets/js/modules/removeMargin.js